<!-- This component is used to display the EFT form -->
<template>
	<div class="flex flex-col gap-4">
		<EftFields
			group="initialAccount"
			field-bank-name
			v-model="paymentDetails.initialAccount"
		/>

		<img
			:src="CheckImage"
			alt="Check"
			class="w-3/5 transform"
		/>

		<FormKit
			type="checkbox"
			name="useDifferentOngoingAccount"
			:label="t('document.useDifferentAccountForOngoingPayments')"
			decorator-icon="StopIcon"
			decorator-icon-class="max-w-none"
			decorator-class="border-gray-400! rounded-md h-6 w-6!"
		/>

		<EftFields
			v-if="paymentDetails!.useDifferentOngoingAccount"
			:ongoing="true"
			group="ongoingAccount"
			bank-name
			v-model="paymentDetails.ongoingAccount"
		/>
		<FormKit
			v-else
			type="group"
			name="ongoingAccount"
		/>
	</div>
</template>

<script setup lang="ts">
import CheckImage from '@/assets/check_image.png'
import EftFields from '@/components/documents/EftFields.vue'
import { usePresentationLocale } from '@/i18n'
import type { EFTPayment } from '@/types'

const { t } = usePresentationLocale()
defineProps<{
	paymentDetails: EFTPayment['paymentDetails']
}>()
</script>

<style scoped>
@reference "tailwindcss";
:deep([data-checked='true'] .formkit-icon) {
	@apply text-green-400;
}

:deep(.formkit-label.required::after) {
	@apply ml-1.5 text-red-500 content-['*'];
}
</style>
